import { render, staticRenderFns } from "./DashTreating.vue?vue&type=template&id=82f7b734&scoped=true&"
import script from "./DashTreating.vue?vue&type=script&lang=js&"
export * from "./DashTreating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f7b734",
  null
  
)

export default component.exports